<template>
    <section class="option__section periods">
        <div class="section__head">
            <h4>Периоды активности</h4>
        </div>
        <div class="periods__list">
            <div class="period" v-for="(p, index) in frame.periods" :key="index">
                <div class="period__row">
                    <label class="field">
                        <span class="field__label"
                            >Начало
                            <img
                                v-if="!p.start"
                                alt="red_star"
                                class="is-empty"
                                src="/images/red_star.svg"
                            />
                        </span>
                        <input
                            class="field__input"
                            type="date"
                            v-model="p.start"
                            :min="minStart"
                            :max="p.end || maxEnd"
                            @change="onDateChange"
                        />
                    </label>

                    <label class="field">
                        <span class="field__label"
                            >Конец
                            <img
                                v-if="!p.end"
                                alt="red_star"
                                class="is-empty"
                                src="/images/red_star.svg"
                            />
                        </span>
                        <input
                            class="field__input"
                            type="date"
                            v-model="p.end"
                            :min="p.start || minStart"
                            :max="maxEnd"
                            @change="onDateChange"
                        />
                    </label>
                    <button
                        v-if="frame.periods.length > 1"
                        @click="removePeriod(index)"
                        class="delete-label"
                    >
                        ×
                    </button>
                </div>
            </div>
            <button @click="addPeriod" class="btn btn--add">+ Добавить период</button>
        </div>
    </section>
</template>

<script>
import { getRtbDateString } from '../../../../utils/timezones';

export default {
    props: ['frame', 'campaignPeriod'],
    emits: ['update:frame'],
    methods: {
        addPeriod() {
            this.frame.periods.push({ start: '', end: '' });
            this.$emit('update:frame', this.frame);
        },
        removePeriod(index) {
            this.frame.periods.splice(index, 1);
            this.$emit('update:frame', this.frame);
        },
        onDateChange() {
            // Уведомляем родительский компонент об изменении дат
            this.$emit('update:frame', this.frame);
        },
    },
    computed: {
        today() {
            return getRtbDateString();
        },
        minStart() {
            if (!this.campaignPeriod?.start) return this.today;
            return this.today > this.campaignPeriod.start ? this.today : this.campaignPeriod.start;
        },
        maxEnd() {
            return this.campaignPeriod?.end || null;
        },
    },
    watch: {
        campaignPeriod: {
            deep: true,
            handler(newPeriod) {
                // Автоматически обновляем даты периодов при изменении периода кампании
                // только если периоды еще не были установлены вручную
                if (newPeriod?.start && newPeriod?.end) {
                    const hasEmptyPeriods = this.frame.periods.length === 0 || 
                        (this.frame.periods.length === 1 && 
                         (!this.frame.periods[0].start || !this.frame.periods[0].end));
                    
                    if (hasEmptyPeriods) {
                        this.frame.periods = [{ start: newPeriod.start, end: newPeriod.end }];
                        this.$emit('update:frame', this.frame);
                    }
                }
            },
            immediate: true,
        },
    },
};
</script>
